<template>

    <div class="dashbord_counters">

        <!--<div class="counter_container">
            <span class="counter_number">
                <animated-number :value="refCount" :formatValue="formatValue" :duration="calcDuration(refCount)" />
            </span>
            <span class="counter_label">{{ $t('modules.dashboard.counters.refs') }}</span>
        </div>-->
        <div class="counter_container">
            <span class="counter_number">
                <animated-number :value="positionCount" :formatValue="formatValue" :duration="calcDuration(positionCount)" />
            </span>
            <span class="counter_label">{{ $t('modules.dashboard.counters.positions') }}</span>
        </div>
        <div class="counter_container">
            <span class="counter_number">
                <animated-number :value="evalCount" :formatValue="formatValue" :duration="calcDuration(evalCount)" />
            </span>
            <span class="counter_label">{{ $t('modules.dashboard.counters.evaluations') }}</span>
        </div>

    </div>

</template>

<script>
import AnimatedNumber from "animated-number-vue";


export default {
    name: 'ItemsCounters',
    components: {
        AnimatedNumber
    },
    beforeCreate() {
        this.$store.dispatch('UserStore/getStats')
    },
    data(){
        return {}
    },
    computed: {
        positionLength(){
            return this.$store.state.PositionStore.positionsList.length
        },
        evalslength(){
            return this.$store.state.EvalStore.evalsList.length
        },
        refsLength(){
            return this.$store.state.RefStore.customRefs.length
        },
        refCount(){
            return this.$store.state.UserStore.stats.sight_refs_count
        },
        evalCount(){
            return this.$store.state.UserStore.stats.evaluations_count
        },
        positionCount(){
            return this.$store.state.UserStore.stats.sight_groups_count
        }
    },
    methods: {
        formatValue(val){
            return val.toFixed(0)
        },
        calcDuration(counter){
            return 350
            // return  counter * 20
            // if(counter == 0){
            //     return 0
            // }else{
            //     return  counter * 20
            // }
        }
    }
}


</script>

<style lang="scss">
.dashbord_counters{
    display: flex;
    justify-content: space-around;
    padding-bottom: 30px;
    border-bottom: 1px solid $grey-lighter;
    .counter_container{
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        .counter_number{
            font-size: 5rem;
            font-weight: 800;
        }
        .counter_label{
            font-weight: 500;
        }
    }
}
</style>